import { CheckboxProps } from '@radix-ui/react-checkbox';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem } from '../ui/form';
import { Checkbox } from '../ui/checkbox';
import { Separator } from '../ui/separator';

interface MultiCheckboxOption {
  label: ReactNode;
  value: string;
}

interface MultiCheckboxFieldProps
  extends Omit<CheckboxProps, 'checked' | 'onCheckedChange'> {
  name: string;
  options: MultiCheckboxOption[];
}

export function MultiCheckboxField({ name, options }: MultiCheckboxFieldProps) {
  const { control, setValue } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const currentValues: string[] = field.value || [];

        const toggleValue = (val: string) => {
          const newValues = currentValues.includes(val)
            ? currentValues.filter(v => v !== val)
            : [...currentValues, val];
          setValue(name, newValues, { shouldValidate: true });
        };

        return (
          <FormItem>
            {options.map(({ label, value }) => (
              <>
                <div
                  key={value}
                  className="flex items-center space-x-4 mb-1 p-2 cursor-pointer"
                  onClick={() => toggleValue(value)}
                >
                  <FormControl>
                    <Checkbox
                      checked={currentValues.includes(value)}
                      onCheckedChange={() => toggleValue(value)}
                      className="rounded-full pointer-events-none"
                    />
                  </FormControl>
                  <span className="text-[16px] text-text-primary select-none">
                    {label}
                  </span>
                </div>

                <div className="pl-10">
                  <Separator />
                </div>
              </>
            ))}
          </FormItem>
        );
      }}
    />
  );
}

export default MultiCheckboxField;
